var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"flex p-4 mb-1 rounded cursor-pointer text-white no-underline w-full hover:bg-gray-800",attrs:{"active-class":"bg-gray-800","to":_vm.route}},[(_vm.icon)?_c('div',{staticClass:"mr-4 w-4"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e(),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }